import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  ICliente,
  ICronograma,
  IFilter,
  IPopulate,
  IQueryParam,
} from 'modelos/src';
import { Subscription } from 'rxjs';

import { Router, ActivatedRoute } from '@angular/router';

import { CronogramasService } from '../../cronogramas/cronogramas.service';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';

@Component({
  selector: 'app-listado-cronogramas',
  templateUrl: './listado-cronogramas.component.html',
  styleUrl: './listado-cronogramas.component.scss',
  standalone: false,
})
export class ListadoCronogramasComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(CronogramasService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);

  //// Tabla nueva
  public name = 'ListadoCronogramasComponent';
  public cronogramas?: ICronograma[];

  public totalCount = 0;
  public columnas?: IColumnas<ICronograma>[];
  //Subs
  public cronogramas$?: Subscription;
  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Colectivos - Crear cronogramas'),
    tooltip: 'Crear cronograma',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];
  //Query
  public filter: IFilter<ICliente> = {};
  public populate: IPopulate = {
    path: 'cliente',
    select: 'nombre',
  };
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // Listars

  public async listar(): Promise<void> {
    this.cronogramas$?.unsubscribe();
    this.cronogramas$ = this.lista2
      .cronogramas(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.cronogramas = data.datos;
      });
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(cronograma: ICronograma) {
    this.navigator.navigate(['editar', cronograma._id], {
      relativeTo: this.route,
    });
  }

  public async eliminar(cronograma: ICronograma) {
    const res = await this.dialogService.confirm(
      'Eliminar cronograma',
      `¿Querés eliminar el cronograma ${cronograma.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(cronograma._id!);
      this.helper.notifSuccess('Cronograma eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla
  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Nombre',
          sortable: true,
        },
        row: {
          field: 'nombre',
          noData: 'Sin nombre',
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        this.columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }
    this.columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Colectivos - Editar cronogramas'),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Colectivos - Eliminar cronogramas'),
          },
        ],
      },
    });
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.cronogramas$?.unsubscribe();
  }
}
